import React, { useEffect, useState } from 'react';
import { RootState } from '@/store';
import { useSelector } from 'react-redux';

import { useGetCurrentUserQuery } from '@/apis/extended/userApi';
import { useAuth } from '@/hooks/useAuth';
import { LoginNotificationModal } from './LoginNotificationModal';

interface AuthWrapperProps {
  children: React.ReactNode;
}

export const AuthWrapper = ({ children }: AuthWrapperProps) => {
  const { isAuthenticated, isLoading } = useAuth();
  const refinanceEnabled = useSelector(
    (state: RootState) => state.mode.refinanceEnabled
  );
  const isInvestorMode = useSelector(
    (state: RootState) => state.mode.isInvestorMode
  );
  const [showLoginNotification, setShowLoginNotification] = useState(false);
  const [hasShownNotification, setHasShownNotification] = useState(false);

  const { data: user, isLoading: userLoading } = useGetCurrentUserQuery(
    undefined,
    {
      skip: !isAuthenticated,
    }
  );

  const isNewUser = (u: { createdAt?: string } | undefined) => {
    if (!u?.createdAt) return false;
    const createdAt = new Date(u.createdAt);
    const now = new Date();
    const twentyFourHoursAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);
    return createdAt > twentyFourHoursAgo;
  };

  useEffect(() => {
    if (
      isAuthenticated &&
      !isLoading &&
      !userLoading &&
      user &&
      !hasShownNotification &&
      isNewUser(user)
    ) {
      setShowLoginNotification(true);
      setHasShownNotification(true);
    }
  }, [isAuthenticated, isLoading, userLoading, user, hasShownNotification]);

  const handleCloseNotification = () => {
    setShowLoginNotification(false);
  };

  return (
    <>
      {children}
      <LoginNotificationModal
        open={showLoginNotification}
        onClose={handleCloseNotification}
        refinanceEnabled={refinanceEnabled}
        isInvestorMode={isInvestorMode}
      />
    </>
  );
};
